import { Image } from "@mantine/core";
import { useTranslation } from "react-i18next";

import { Modal } from "../../Modal";

import type { FC } from "react";

interface Props {
  opened: boolean;
  handleCancel: () => void;
  avatarUrl: string | null | undefined;
  uploadedFileName: string | null;
}

const ModalPreviewUserAvatar: FC<Props> = ({
  opened,
  handleCancel,
  avatarUrl,
  uploadedFileName,
}) => {
  const { t } = useTranslation();

  if (!opened) return null;

  return (
    <Modal
      opened={opened}
      onClose={handleCancel}
      title={t("profile.profile_image")}
      size="md"
      centered
    >
      <Image src={avatarUrl} alt={uploadedFileName || "User avatar"} />
    </Modal>
  );
};

export default ModalPreviewUserAvatar;
